import script from "./index_v2.vue?vue&type=script&lang=ts&setup=true"
export * from "./index_v2.vue?vue&type=script&lang=ts&setup=true"

import "./index_v2.vue?vue&type=style&index=0&id=7ec8e674&lang=less&scoped=true"

import exportComponent from "C:\\Users\\bruce\\Desktop\\优海项目\\新git仓库\\uhi_hik_dock\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7ec8e674"]])

export default __exports__